import { render, staticRenderFns } from "./RoleProfessional.vue?vue&type=template&id=b8bed8d2"
import script from "./RoleProfessional.vue?vue&type=script&lang=js"
export * from "./RoleProfessional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports